<template>
  <div class="dropdown" @mouseleave="closeDropdown">
    <!-- Le texte "Produits" redirige directement vers la page produits -->
    <router-link to="/produits" class="dropdown-text" >Produits</router-link>
    
    <!-- L'icône permet de basculer le menu déroulant -->
    <button @click="toggleDropdown" class="dropdown-toggle">
      <i :class="isDropdownOpen ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"></i>
    </button>

    <!-- Menu déroulant -->
    <ul v-if="isDropdownOpen" class="dropdown-menu"> 
      <li @click="closeDropdown"><router-link to="/equipementlabo">Équipement Labo</router-link></li>
      <li @click="closeDropdown"><router-link to="/consomablesComp">Consommable</router-link></li>
      <li @click="closeDropdown"><router-link to="/reactifs">Réactifs</router-link></li>
      <li @click="closeDropdown"><router-link to="/bacteriologie">Bactériologie</router-link></li>
      <li @click="closeDropdown"><router-link to="/chimiques">Chimiques</router-link></li>
      <li @click="closeDropdown"><router-link to="/vitamines-mineraux">Vitamines & Minéraux</router-link></li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "DropdownComponent",
  data() {
    return {
      isDropdownOpen: false,
    };
  },
  methods: {
    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen;
      console.log("Dropdown ouvert ?", this.isDropdownOpen);
    },
    closeDropdown() {
      this.isDropdownOpen = false;
       console.log("Dropdown fermé"); 
    },
  },
};
</script>

<style scoped>
:root{
  --brand:#00998B;
  --brand-dark:#05305b;
  --ink:#22313a;
}

/* Wrapper */
.dropdown{
  position:relative;
  display:inline-flex; align-items:center; gap:6px;
  height:100%;
}

/* Lien trigger — même look que les liens nav */
.dropdown-text{
  display:inline-flex; align-items:center;
  color:var(--ink);
  font-size:15px; font-weight:700; letter-spacing:.01em;
  padding:8px 2px; text-decoration:none; cursor:pointer;
  position:relative; transition:color .15s ease;
  font-family:'Helvetica Neue',ui-sans-serif,system-ui,-apple-system,"Segoe UI",Roboto,Arial;
}
.dropdown-text::after{
  content:""; position:absolute; left:0; bottom:0; height:2px; width:0%;
  background:var(--brand); transition:width .22s ease;
}
.dropdown:hover .dropdown-text::after{ width:100%; }

/* Chevron */
.dropdown-toggle{
  background:transparent; border:0; cursor:pointer;
  display:grid; place-items:center; padding:4px;
  color:var(--ink); font-size:12px; line-height:1;
  transition:transform .2s ease, color .2s ease;
}
.dropdown-toggle i{ margin-left:0; }
.dropdown-toggle[aria-expanded="true"]{ color:var(--brand-dark); transform:rotate(180deg); }

/* Panneau (flottant) */
.dropdown-menu{
  position:absolute; top: calc(100% + 10px); left: 50%; transform: translateX(-50%);
  min-width: 260px; max-width: 340px;
  background: rgba(255,255,255,.98);
  border:1px solid rgba(0,0,0,.06); border-radius:12px;
  box-shadow: 0 20px 44px rgba(0,0,0,.14);
  backdrop-filter: blur(6px);
  padding:8px; margin:0; list-style:none; z-index:1001;
}

/* Items */
.dropdown-menu li{ border-radius:10px; }
.dropdown-menu li a{
  display:flex; align-items:center; gap:10px;
  padding:10px 12px; border-radius:10px;
  color:#22313a; text-decoration:none; font-weight:600; font-size:14px;
  transition: background .15s ease, color .15s ease, transform .15s ease;
}
.dropdown-menu li a:hover{
  background:#eefbf9; color:var(--brand-dark);
  transform: translateY(-1px);
}

/* Petit caret */
.dropdown-menu::before{
  content:""; position:absolute; top:-6px; left:50%; transform:translateX(-50%) rotate(45deg);
  width:12px; height:12px; background:#fff;
  border-left:1px solid rgba(0,0,0,.06); border-top:1px solid rgba(0,0,0,.06);
}

/* ===== Responsive : dans la sidebar (≤1040px), on passe en bloc ===== */
@media (max-width:1040px){
  .dropdown{ width:100%; }
  .dropdown-text{ padding:12px 6px; }
  .dropdown-menu{
    position:static; transform:none;
    width:100%; min-width:0; max-width:none;
    margin-top:6px; border-radius:12px; box-shadow:none;
    background:#fff; border:1px solid rgba(0,0,0,.06);
  }
  .dropdown-menu::before{ display:none; }
}

/* ===== Mode sombre ===== */
@media (prefers-color-scheme: dark){
  .dropdown-text, .dropdown-toggle{ color:#e6edf1; }
  .dropdown-text::after{ background:#73d8cf; }
  .dropdown-menu{
    background:#0f1720; border-color:rgba(255,255,255,.06);
    box-shadow:0 20px 44px rgba(0,0,0,.5);
  }
  .dropdown-menu::before{
    background:#0f1720; border-color:rgba(255,255,255,.06);
  }
  .dropdown-menu li a{ color:#e6edf1; }
  .dropdown-menu li a:hover{ background:#142231; color:#a5f3ee; }
}
</style>

